module.exports = __webpack_public_path__ + "img/asesor.c2d6751b.png";